<template>
  <div class="cursor" :style="style" v-show="visible" :class="{'over-target': !!hoverTarget}" >
    <div class="circle" />
  </div>
</template>

<script>
import { ElasticNumber, RAF } from '@monogrid/js-utils'
import delay from 'lodash/delay'

export default {
  name: 'CursorComponent',
  data () {
    return {
      visible: true,
      hoverTarget: null,
      hoverAlignment: 'center center',
      style: {
        transform: 'translate3d(0, 0, 0)'
      }
    }
  },
  created () {
    this.x = new ElasticNumber(0)
    this.y = new ElasticNumber(0)
    // this.scrollValue = 0
  },
  mounted () {
    this.time = new Date().getTime()
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('touchmove', this.onMouseMove)

    document.addEventListener('mouseover', this.onMouseOver)
    document.addEventListener('mouseout', this.onMouseOut)
    document.addEventListener('click', this.onMouseOut)
    RAF.add(this.update)
  },
  destroyed () {
    RAF.remove(this.update)
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('touchmove', this.onMouseMove)

    document.removeEventListener('mouseover', this.onMouseOver)
    document.removeEventListener('mouseout', this.onMouseOut)
    document.removeEventListener('click', this.onMouseOut)
  },
  watch: {
    async $route () {
      this.visible = false
      this.x.target = this.x.value = 0
      this.y.target = this.y.value = 0

      delay(() => {
        this.x.target = this.x.value = this.lastPositionX
        this.y.target = this.y.value = this.lastPositionY
      }, 100)
      this.visible = true
    }
  },
  methods: {
    searchData (domElement) {
      if (!domElement) {
        return false
      }
      if (domElement.dataset && domElement.dataset.cursorTarget !== null && domElement.dataset.cursorTarget !== undefined) {
        return domElement
      }
      if (domElement.parentNode) {
        return this.searchData(domElement.parentNode)
      }
      return false
    },
    onMouseOut (e) {
      const dataTarget = this.searchData(e.target)
      if (dataTarget) {
        // console.log('clear')
        this.hoverTarget = null
      }
    },
    onMouseOver (e) {
      const dataTarget = this.searchData(e.target)
      if (dataTarget) {
        // console.log('hover')
        const rect = dataTarget.getBoundingClientRect()
        // const data = JSON.parse(dataTarget.dataset.hoverDotTarget)
        this.hoverAlignment = dataTarget.dataset.cursorTarget.toString().split(' ') || 'center center'
        this.hoverTarget = rect
      }
    },
    onMouseMove (e) {
      this.x.target = (e.touches && e.touches.length > 0 ? e.touches[0].clientX : e.clientX)
      this.y.target = (e.touches && e.touches.length > 0 ? e.touches[0].clientY : e.clientY) // + this.scrollValue

      this.lastPositionX = this.x.target
      this.lastPositionY = this.y.target
    },
    update () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000
      if (this.hoverTarget) {
        this.x.target = this.hoverTarget.x
        this.y.target = this.hoverTarget.y

        switch (this.hoverAlignment[0]) {
          case 'center':
            this.x.target += (this.hoverTarget.width / 2)
            break
          case 'right':
            this.x.target += this.hoverTarget.width
            break
        }
        switch (this.hoverAlignment[1]) {
          case 'center':
            this.y.target += (this.hoverTarget.height / 2)
            break
          case 'bottom':
            this.y.target += this.hoverTarget.height
            break
        }
      }
      this.x.update(delta)
      this.y.update(delta)
      this.time = now
      this.style = {
        transform: `translate3d(${this.x.value - 20}px, ${this.y.value - 20}px, 0)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cursor {
  pointer-events: none;
  user-select: none;
  backface-visibility: none;
  width: 40px;
  height: 40px;
  position: fixed;
  z-index: $z-cursor;

  .circle {
    border: 1px solid $c-pink;
    border-radius: 50%;
    transform-origin: 50% 50%;
    transition: transform 0.5s $ease-in-out-cubic, opacity 0.25s $ease-in-out-cubic 0.25s;
  }

  &.over-target {
    .circle {
      transform: scale3d(0.8, 0.8, 0.8);
      opacity: 0;
    }
  }
}
</style>
